import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { CodeInput } from "./CodeInput";
import "../styles/LoginModal.css";

interface LoginModalProps {
  onClose: () => void;
}

export function LoginModal({ onClose }: LoginModalProps) {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      await login(email);
      setSuccess(true);
    } catch (err: any) {
      setError(err.response?.data?.error || err.message || "Failed to send login link");
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
          <h2>Check your email!</h2>
          <p>We've sent a magic login link to <strong>{email}</strong>.</p>
          <p>Click the link in your email to log in.</p>
          
          <CodeInput 
            onSuccess={onClose}
            onError={(error) => console.error("Code verification failed:", error)}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        <h2>Log in to Dream Directory</h2>
        <p>Enter your email to receive a magic login link</p>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="your@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
            className="modal-input"
          />

          {error && <div className="modal-error">{error}</div>}

          <button
            type="submit"
            disabled={loading || !email}
            className="modal-button"
          >
            {loading ? "Sending..." : "Send magic link"}
          </button>
        </form>

        <p className="modal-hint">
          Don't have an account? Click "Join the Network" to sign up.
        </p>
      </div>
    </div>
  );
}
